<template>
<el-dialog :visible.sync="show" title="批量返款" width="450px">
  <div class="content">
    <div>已选 <b class="primary-color">{{ list.length }}</b> 单，总订单金额<b class="primary-color">￥{{ orderAmount | filterAmount }}</b>，确认已打款了吗？</div>
  </div>
  <div slot="footer">
    <el-button size="mini" @click="$emit('close')">取消</el-button>
    <el-button size="mini" type="primary" @click="onRefundBatch">确定</el-button>
  </div>
</el-dialog>
</template>

<script>
import { moneyFormatFn } from '@/page/component/routes/index/order-manage/order-list/fields'
import { refundBatch } from '@/service/apis/order'
export default {
  name: 'refundBatchDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    roleType: {
      type: Number,
      default: null
    }
  }, 
  computed: {
    orderAmount () {
      var rst = 0
      if (this.list.length) {
        this.list.forEach(item => {
          rst += Number(item.orderAmount)
        })
      }
      return rst
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  filters: {
    filterAmount (val) {
      return moneyFormatFn(val) || 0
    }
  },
  methods: {
    onRefundBatch () {
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      refundBatch.call(this, {
        idList: this.list.map(item => item.id),
        roleType: this.roleType
      }).then(res => {
        if (res) {
          this.$message.success('批量返款')
          this.$emit('on-success')
        }
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>
.content {
  padding: 12px 0;
  line-height: 28px;
  font-size: 16px;
}
</style>
